<ag-grid-angular
	class="ag-theme-balham copo-table-inner-margin"
	[gridOptions]="gridOptions"
	[modules]="agGridModule"
	[columnDefs]="columnDefs"
	[rowData]="rowData"
	(gridReady)="onGridReady($event)"
	(viewportChanged)="onViewportChanged($event)"
	[getRowHeight]="getRowHeight"
></ag-grid-angular>